import { render, staticRenderFns } from "./RemoveSelectedItemButton.vue?vue&type=template&id=dd78e666"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd78e666')) {
      api.createRecord('dd78e666', component.options)
    } else {
      api.reload('dd78e666', component.options)
    }
    module.hot.accept("./RemoveSelectedItemButton.vue?vue&type=template&id=dd78e666", function () {
      api.rerender('dd78e666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/RemoveSelectedItemButton.vue"
export default component.exports